Ext.define('SA.view.sidebar.business.searcheditor.ConditionsPanel', {
    alias: 'widget.business-conditions',
    extend: 'SA.view.SimpleContainer',

    booleanOperator: 'and',

    addRow() {
        var row;

        if (this.down('business-condition-row')) {
            this.add({
                xtype: 'divider-combo-button',
                items: ['and', 'or'],
                margin: '12 0 12 5',
                value: this.booleanOperator,

                selectHandler: value => {
                    if (this.booleanOperator !== value) {
                        this.booleanOperator = value;

                        this.refresh();
                    }
                }
            });
        }

        row = this.add({xtype: 'business-condition-row'});

        this.refresh();

        return row;
    },

    getBooleanOperator() {
        return this.booleanOperator;
    },

    getQuery() {
        return this.query('business-condition-row').map(row => row.getCondition());
    },

    refresh() {
        var booleanOperator = this.booleanOperator;

        this.query('divider-combo-button').forEach(combo => {
            combo.setValue(booleanOperator);
        });

        this.fireEvent('refresh:conditions', this);
    }
});